import isServer from '@hydra/utils/isServer';

const Settings = values => ({
  set: function (settings) {
    values = Object.assign(
      {},
      settings.common,
      isServer() ? settings.server : settings.client
    );
  },

  get: function (key) {
    if (!values && !isServer()) {
      this.set(window.sharedConfig);
    }

    return (values && key) ? values[key] : values;
  },

  add: function (newKeys) {
    values = Object.assign(values, newKeys);
  }
});

const settings = Settings();
settings._settings = Settings;

export default settings;
